import React from "react";
import {
  StyledInfoContent,
  StyledIcon,
  StyledDescription,
  StyledDivider,
} from "./InfoContent.styled";
import { theme } from "../../../style/theme";
import { InfoText } from "../../../data/types/InfoText";
import { Heading } from "../../general/Heading/Heading";

export const InfoContent: React.FC<InfoText> = ({ title, descriptions }) => {
  return (
    <StyledInfoContent>
      <StyledIcon name="GlascBug2" />
      <Heading type="h2" color={theme.colors.magenta} textTransform="uppercase">
        {title}
      </Heading>
      <StyledDivider />
      <StyledDescription>
        {descriptions &&
          descriptions.map((description, index) => (
            <span key={`${title} - description - ${index}`}>{description}</span>
          ))}
      </StyledDescription>
    </StyledInfoContent>
  );
};
